import { EDM_PAY } from '@constants/features'
import { useHasFeature } from '@hooks/useThemeParams'

/**
 * Marca sob a qual o comprador está vendo a área de membros.
 *
 * O members não tem domínio próprio por marca (o aluno acessa pelo domínio da
 * escola), então quem decide é a feature `edm_pay` da escola — a mesma fonte que
 * o core, o hermes e o checkout usam. Ela chega em `school.featuresAvailable`.
 */
export interface IBrand {
  name: string
  /** Contato de atendimento ao comprador. */
  supportEmail: string
  /** Contato para pendências de reembolso/pagamento. */
  paymentsEmail: string
}

export const HEROSPARK_BRAND: IBrand = {
  name: 'HeroSpark',
  supportEmail: 'suporte@herospark.com',
  paymentsEmail: 'payments@herospark.com.br',
}

// A EDM atende comprador e reembolso pelo mesmo endereço.
export const EDMPAY_BRAND: IBrand = {
  name: 'EntregaPay',
  supportEmail: 'atendimento@entregadigital.app.br',
  paymentsEmail: 'atendimento@entregadigital.app.br',
}

export const useBrand = (): IBrand => {
  const isEdmPay = useHasFeature(EDM_PAY)

  return isEdmPay ? EDMPAY_BRAND : HEROSPARK_BRAND
}
